import { Context } from "@nuxt/types/app";

import getGetBytesFromKB from "./unit.getBytesFromKB.plugin";
import getGetBytesFromMB from "./unit.getBytesFromMB.plugin";
import getGetKBFromBytes from "./unit.getKBFromBytes.plugin";
import getGetKBFromMB from "./unit.getKBFromMB.plugin";
import getGetMBFromBytes from "./unit.getMBFromBytes.plugin";
import getGetMBFromKB from "./unit.getMBFromKB.plugin";
import getGetOrdinal from "./unit.getOrdinal.plugin";
import getGetTypeFromFileType from "./unit.getTypeFromFileType.plugin";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function unitPlugin(context: Context) {
  const { getTypeFromFileType } = getGetTypeFromFileType(context);
  const { getBytesFromMB } = getGetBytesFromMB(context);
  const { getBytesFromKB } = getGetBytesFromKB(context);
  const { getKBFromBytes } = getGetKBFromBytes(context);
  const { getKBFromMB } = getGetKBFromMB(context);
  const { getMBFromBytes } = getGetMBFromBytes(context);
  const { getMBFromKB } = getGetMBFromKB(context);
  const { getOrdinal } = getGetOrdinal(context);

  return {
    getTypeFromFileType,
    getBytesFromMB,
    getBytesFromKB,
    getKBFromBytes,
    getKBFromMB,
    getMBFromBytes,
    getMBFromKB,
    getOrdinal,
  };
}
